<template src="./dashboard.html"></template>

<script>
    export default {
        name: 'dashboard',
        data() {
            return {
                reviews: [],
                popularProducts: [],
                errors: []
            }
        },
        computed: {
            system() {
                return this.$root.$data.system
            },
            heading() {
                if (this.system && this.system.dashboard && this.system.dashboard.hero && this.system.dashboard.hero.heading) {
                    return this.system.dashboard.hero.heading;
                }
                return "All your print requirements<br />in <strong>one place.</strong>";
            },
            heroImageOverride() {
                if (this.system && this.system.dashboard && this.system.dashboard.hero && this.system.dashboard.hero.image) {
                    return "background-image: url('" + this.system.dashboard.hero.image + "')";
                }
                return "";
            }
        },
        methods: {
            heroButtonClass() {
                var num = this.system.dashboard.hero.features.length + 1;
                if (num > 10) {
                    num = 10
                }
                return ['delay-'+num];
            },
            moveCarousel(event) {
                let currentPosition = event.currentTarget.getAttribute('data-order');
                let movePosition = 3 - currentPosition;
                let totalReviewsNo = this.reviews.length;

                for (let i = 0; i < totalReviewsNo; i++) {
                    let newPosition = this.reviews[i].order + movePosition;

                    if ((totalReviewsNo > 5 && newPosition < 0) || newPosition < 1) {
                        newPosition = totalReviewsNo + newPosition;
                    }
                    if (newPosition > totalReviewsNo) {
                        newPosition = newPosition - totalReviewsNo;
                    }

                    this.reviews[i].order = newPosition;
                }
            }
        },
        // TODO: change the api urls to eg:(/api/testimonials) etc.
        // TODO: hook in the products after the Products model is done
        mounted() {
            this.axios.get('/api/testimonials')
                .then(response => {

                    response.data.data.forEach((v, i) => {
                        v.order = i + 1;
                    });

                    this.reviews = response.data.data;

                })
                .catch(e => {
                    this.errors.push(e)
                });

            this.axios.get('/api/popular-products')
                .then(response => {
                    this.popularProducts = response.data
                })
                .catch(e => {
                    this.errors.push(e)
                });
        }
    }
</script>

<style lang="scss" scoped>
    @import 'dashboard.scss';
</style>


// WEBPACK FOOTER //
// src/components/pages/dashboard/dashboard.vue